module.exports = __webpack_public_path__ + "img/money.7c9cb3bd.svg";